import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Subtitle, BackIcon, NextIcon } from '../index';

import {
    StyledContainedButton,
    StyledTextButton,
    StyledRectangleButton,
    StyledGoBackButtonContainer,
    StyledIconButton,
    StyledFilledIconButton,
    StyledOutlinedButton,
    StyledProfileMenuButton,
} from './style';

export const ContainedButton = (props) => {
    const { children, loading, disabled, ...rest } = props;

    return (
        <StyledContainedButton {...rest} variant="contained" disabled={loading || disabled}>
            {loading ? <CircularProgress style={{ width: '20px', height: '20px' }} /> : children}
        </StyledContainedButton>
    );
};

ContainedButton.propTypes = {
    children: PropTypes.any,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
};

export const OutlinedButton = (props) => {
    const { children, ...rest } = props;

    return (
        <StyledOutlinedButton {...rest} variant="outlined">
            {children}
        </StyledOutlinedButton>
    );
};

OutlinedButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const TextButton = (props) => {
    const { children, ...rest } = props;

    return <StyledTextButton {...rest}>{children}</StyledTextButton>;
};

TextButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const RectangleButton = (props) => {
    const { children, ...rest } = props;

    return (
        <StyledRectangleButton {...rest} variant="contained">
            {children}
        </StyledRectangleButton>
    );
};

RectangleButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const GoBackButton = (props) => {
    const { $text, onClick, mobileS, disabled } = props;
    return $text ? (
        <StyledGoBackButtonContainer
            onClick={disabled ? () => {} : () => onClick()}
            disabled={disabled}
        >
            <BackIcon />
            <Subtitle margin="0 0 0 10px" $textColor="black">
                Back to previous page
            </Subtitle>
        </StyledGoBackButtonContainer>
    ) : (
        <IconButton
            onClick={onClick}
            style={{ marginLeft: mobileS ? '-5px' : '-15px' }}
            disabled={disabled}
        >
            <BackIcon />
        </IconButton>
    );
};

GoBackButton.propTypes = {
    $text: PropTypes.bool,
    onClick: PropTypes.func,
    mobileS: PropTypes.bool,
    disabled: PropTypes.bool,
};

export const IconButton = (props) => {
    const { children, ...rest } = props;

    return <StyledIconButton {...rest}>{children}</StyledIconButton>;
};

IconButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const FilledIconButton = (props) => {
    const { children, loading, disabled, ...rest } = props;

    return (
        <StyledFilledIconButton {...rest} disabled={loading || disabled}>
            {loading ? <CircularProgress style={{ width: '20px', height: '20px' }} /> : children}
        </StyledFilledIconButton>
    );
};

FilledIconButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const ProfileMenuButton = (props) => {
    const { children, showNextIcon, ...rest } = props;

    return (
        <StyledProfileMenuButton variant="outlined" {...rest}>
            {children}
            {showNextIcon && (
                <div
                    style={{
                        display: 'flex',
                        flex: '1 1 0',
                        justifyContent: 'flex-end',
                    }}
                >
                    <NextIcon fill="black" />
                </div>
            )}
        </StyledProfileMenuButton>
    );
};

ProfileMenuButton.propTypes = {
    children: PropTypes.any,
    showNextIcon: PropTypes.bool,
    rest: PropTypes.object,
};
